import { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Pic from '../../../../assets/images/kiwi_profile_pic.png';
import { useUserService } from '../../../hooks';
import { User } from '../../../../domain/entities';

const ProfilePic = () => {
  const UserService = useUserService();

  const [user, setUser] = useState<User>({ id: '', name: '', email: '', role: 'user' });

  useEffect(() => {
    setUser(UserService.getUser());
  }, []);

  return (
    <div className={styles['profile-info']}>
      <div className={styles['profile-info__pic-container']}>
        <img className={styles['profile-info__pic']} src={Pic} alt='profile_pic' />
      </div>
      <p className={styles['profile-info__name']}>{user.name}</p>
    </div>
  );
};

export default ProfilePic;
